import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from "@angular/forms";

import { environment } from 'src/environments/environment';
import { MenuService } from 'src/app/service/MenuService';
import { TranslateService } from '@ngx-translate/core';
import { BpsEmailValidator } from 'src/app/validator/BpsEmailValidator';
import { BaseComponent } from '../common/BaseComponent';
import { CommonService } from 'src/app/service/CommonService';
import { ContactUsService } from 'src/app/service/ContactUsService';
@Component({
  selector: 'app-pki-login',
  templateUrl: './pki-login.component.html'
})

export class PkiLoginComponent implements OnInit, OnDestroy {
  @ViewChild('oamPkiLoginForm') oamLoginFormElement: ElementRef;
  @ViewChild('pageMsg') pageMsgElement: ElementRef;
  oamSubmitUri = environment.getOamServerUri();

  certificateUrl;
  showPassword: boolean = false;
  submitted = false;
  errorCode = "";
  notMatch = false;

  constructor(
    public fb: FormBuilder,
    public route: ActivatedRoute,
    public router: Router,
    public translate: TranslateService,
    public menuService: MenuService,
    public commonService: CommonService,
    public contactService: ContactUsService) {
    menuService.setDisplayStatusByMenuType('login');
  }

  loginForm = this.fb.group({
    username: ['', [Validators.required, BpsEmailValidator.restricted]],
    password: ['', [Validators.required]],
    bmctx: [''],
    request_id: ['']
  });

  ngOnInit(): void {
    //sessionStorage.clear(); 
    //only remove user, but to keep currentLang
    sessionStorage.removeItem("user");
    this.route.queryParams
      .subscribe(params => {
        console.log(params);
        this.errorCode = (params['p_error_code'])?.trim() ?? '';
        const endUrl = (params['end_url'])?.trim() ?? '';
        const fullResourceUrl = (params['resource_url'])?.trim() ?? '';
        const clientID = (params['client_id'])?.trim() ?? '';
        let resourceUrl: string = null;

        
        resourceUrl = CommonService.determineSigninUrl(fullResourceUrl);
        resourceUrl = this.getMappingURL(resourceUrl);        
        if(!resourceUrl.includes('/opsbpssecure/secure')){
          this.contactService.setDisplayStatusByPageType('login');
        } else {
          this.contactService.setDisplayStatusByPageType('opsbps');
        }
        
        const reqid = (params['request_id'])?.trim() ?? '';

        this.notMatch = this.errorCode.length > 0;
        this.certificateUrl = (endUrl === '') ? resourceUrl : endUrl;
        this.certificateUrl = (this.certificateUrl === '') ? sessionStorage.getItem("resource_url") : this.certificateUrl;
        sessionStorage.setItem("resource_url", this.certificateUrl);

      }
      );
  }

  ngOnDestroy(): void { }

  ngAfterViewInit() {
    if (this.pageMsgElement !== undefined) {
      this.pageMsgElement.nativeElement.focus();
      this.pageMsgElement.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  onCertificateLogin() {
    const redirectUrl = environment.getOamCertificateUri() + "?end_url=" + this.certificateUrl;
    window.location.href = redirectUrl;
  }

  // make an api call to retrieve the mfa url
  getMappingURL(signinURL: string): string {
    if (signinURL) {
      signinURL = decodeURIComponent(signinURL);
      this.commonService.getURL(signinURL).subscribe(response => {
        console.log("get-sigin-url:" + JSON.stringify(response));
        if (response.result == 1) {
          return null;
        } else {
          return response.usermfaURL;
        }
      });
    }
    return signinURL;
  }

}
